import styled from '@emotion/styled';

const ARROW_DOWN = '"\\00a0\\f104"';
const ARROW_UP = '"\\00a0\\f10d"';

const HeaderCell = styled.div(
  ({ theme }) => ({
    backgroundColor: theme.color.panel,
    display: 'table-cell',
    padding: '0.5em 0em',
    textTransform: 'uppercase'
  }),
  ({ textAlign }) => ({
    textAlign
  }),
  ({ showSortKey, sortDescending }) => ({
    '&::after': {
      content: sortDescending ? ARROW_DOWN : ARROW_UP,
      fontFamily: 'Ionicons',
      visibility: showSortKey ? 'visible' : 'hidden'
    }
  })
);

export default HeaderCell;
